import { render, staticRenderFns } from "./PlaceDeleteDialog.vue?vue&type=template&id=0355d290"
import script from "./PlaceDeleteDialog.vue?vue&type=script&lang=js"
export * from "./PlaceDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports